export default __webpack_public_path__ + "assets/adb48d424726a2397eb1d40366388715.png";